import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);

  const grouped = faqs.reduce((acc, f) => { (acc[f.category || "General"] = acc[f.category || "General"] || []).push(f); return acc; }, {});

  return (
    <div data-testid="page-faqs" className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-14">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">FAQs</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1]">Questions we're often asked.</h1>
      </section>
      <section className="container-editorial pb-24 overflow-hidden">
        <div className="grid grid-cols-12 gap-8">
          {Object.entries(grouped).map(([cat, items]) => (
            <div key={cat} className="col-span-12">
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#A85C42] mb-4">{cat}</div>
              <Accordion type="single" collapsible className="border-t border-[#D5D0C8]">
                {items.map((f) => (
                  <AccordionItem key={f.id} value={f.id} className="border-b border-[#D5D0C8]">
                    <AccordionTrigger data-testid={`faq-${f.id}`} className="font-serif text-xl md:text-2xl tracking-tight text-left">{f.question}</AccordionTrigger>
                    <AccordionContent className="text-[#4A4642] leading-relaxed">{f.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
        <div className="mt-16 border-t border-[#D5D0C8] pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="text-[#4A4642]">Still have a question we haven't answered?</div>
          <Link to="/contact" className="px-8 py-4 bg-[#2B2927] text-[#F9F8F6] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#A85C42] transition-colors">Write to us</Link>
        </div>
      </section>
    </div>
  );
}
